import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MainService } from 'src/app/modules/main/services/main.service';
import { DataService } from './data.service';
import { ProtoService } from './proto.service';

@Injectable({
  providedIn: 'root'
})
export class LocationsService {

  private locationActiveId: string = '';

  private locationActive = new BehaviorSubject<any>(null);

  private locations = new BehaviorSubject<Array<any>>([]);

  private numLocations: number = 0;

  private locationsProtos: Array<any> = [];

  constructor(
              private mainSrv: MainService,
              private dataSrv: DataService,
              private protoSrv: ProtoService
  ) { }

  public getLocation(): any {
    return this.locationActive.value;
  }
  
  public getLocationActive(): Observable<any> {
    return this.locationActive;
  }

  public setLocationActive(location: any): void {
    // console.log(location);
    if (location) {
      this.locationActiveId = location.id;
      this.mainSrv.setLocation(location.id, location.name);
      this.dataSrv.setBusinessActive(false);
    }
    this.locationActive.next(location);
  }

  public setLocations(locations: Array<any>): void {
    this.locations.next(locations);
  }

  public getLocations(): Observable<Array<any>> {
    return this.locations;
  }

  public getAllLocations(): void {
    this.mainSrv.getLocations().subscribe(data => {
      const answer = this.protoSrv.decodeFindLocationsByUserAndBusinessActionProtoResponse(data);
      if (this.protoSrv.isFindLocationsSuccess(answer)) {
        const aux: any = this.getAllLocationsFromProto(answer);
        let locations: Array<any> = [];
        let index = 0;
        aux.forEach(element => {
          element.logoUrl = this.dataSrv.getBusinessLogoUrl();
          element.index = index;
          locations.push(element);
          index += 1;
          this.numLocations += 1;
        });
        this.locations.next(locations);
      }
    });
  }

  public getAllLocationsFromProto(proto: any): Array<any> {
    const locations: any = [];
    const aux = this.protoSrv.getLocationsFromFindLocationsByUserAndBusinessActionProtoResponse(proto);
    let location;
    aux.forEach(element => {
      location = this.protoSrv.getLocationInfo(element);
      locations.push(location);
      this.locationsProtos[location.id] = element;
    });
    this.mainSrv.setLocationProtos(this.locationsProtos);
    return locations;
  }

  public reset(): void {
    this.locationActiveId = '';
    this.locationActive.next(null);
    this.locations.next([]);
    this.locationsProtos = [];
  }
}
